<template>
  <div>
    <div class="pa-0 ma-0">
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
          <div class="fonts-white container pl-0 pr-1">
            <div class="overlay-grey-web">
              <!-- Header Section -->
              <div class="collections-header">
                <div class="header-content">
                  <v-icon class="header-icon">mdi-image-frame</v-icon>
                  <h1 class="header-title">NFT Collections</h1>
                </div>
                <p class="header-subtitle">
                  Your exclusive music NFTs, geo-located tracks, and location recordings
                </p>

                <!-- Action Buttons -->
                <div class="header-actions">
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-refresh"
                    @click="refreshCollections()"
                    class="action-btn"
                  >
                    Refresh
                  </v-btn>
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-plus"
                    @click="findNFT()"
                    class="action-btn create-btn"
                  >
                    Find NFT
                  </v-btn>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Search and Filters Section -->
              <div class="collections-section">
                <div class="search-filters-container">
                  <!-- Search Field -->
                  <v-text-field
                    v-model="searchQuery"
                    placeholder="Search NFTs by name, artist, or token ID..."
                    prepend-inner-icon="mdi-magnify"
                    density="comfortable"
                    hide-details
                    clearable
                    class="search-field"
                    variant="outlined"
                  >
                    <template v-slot:append-inner>
                      <v-fade-transition leave-absolute>
                        <v-progress-circular
                          v-if="searching"
                          size="24"
                          color="white"
                          indeterminate
                        ></v-progress-circular>
                      </v-fade-transition>
                    </template>
                  </v-text-field>

                  <!-- NFT Type Filter -->
                  <v-select
                    v-model="nftFilter"
                    :items="filterOptions"
                    label="NFT Type"
                    density="comfortable"
                    hide-details
                    class="filter-select"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="20">mdi-filter-variant</v-icon>
                    </template>
                  </v-select>

                  <!-- Sort Select -->
                  <v-select
                    v-model="sortBy"
                    :items="sortOptions"
                    label="Sort by"
                    density="comfortable"
                    hide-details
                    class="sort-select"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="20">mdi-sort</v-icon>
                    </template>
                  </v-select>
                </div>

                <!-- Results Counter -->
                <div class="results-info">
                  <span class="results-text">
                    Showing {{ filteredNFTs.length }} of {{ totalNFTs }} NFTs
                  </span>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- NFT Grid -->
              <div class="nft-content">
                <div v-if="filteredNFTs.length > 0 || hasSampleNFTs" class="nft-grid">
                  <!-- Standard Music NFT (Sample) -->
                  <div 
                    v-if="showSampleNFT('standard')" 
                    class="nft-card sample-nft"
                  >
                    <div class="nft-badge-container">
                      <v-chip size="small" color="purple" class="nft-type-badge">
                        <v-icon left size="14">mdi-music-box</v-icon>
                        Music NFT
                      </v-chip>
                      <div class="sample-overlay-badge">
                        <v-chip size="small" color="grey" variant="outlined">
                          <v-icon left size="12">mdi-information</v-icon>
                          Sample
                        </v-chip>
                      </div>
                    </div>

                    <div class="nft-image">
                        <img src="@/assets/images/muzible_muze.webp" alt="NFT Cover" />
                      <div class="nft-overlay">
                        <v-btn
                          icon
                          size="x-large"
                          variant="text"
                          class="play-btn-nft"
                          disabled
                        >
                          <v-icon size="48">mdi-play-circle</v-icon>
                        </v-btn>
                      </div>
                      <div class="nft-rarity">
                        <v-chip size="x-small" color="gold" class="rarity-chip">
                          <v-icon left size="12">mdi-star</v-icon>
                          Rare
                        </v-chip>
                      </div>
                    </div>

                    <div class="nft-content-body">
                      <div class="nft-header">
                        <h3 class="nft-title sample-text">Epic Electronic Anthem</h3>
                        <p class="nft-artist sample-text">
                          <v-icon size="14" class="artist-icon">mdi-account-music</v-icon>
                          Sample Artist
                        </p>
                      </div>

                      <div class="nft-details">
                        <div class="detail-row">
                          <span class="detail-label">Token ID:</span>
                          <span class="detail-value sample-text">#1234567890</span>
                        </div>
                        <div class="detail-row">
                          <span class="detail-label">Edition:</span>
                          <span class="detail-value sample-text">1 of 100</span>
                        </div>
                        <div class="detail-row">
                          <span class="detail-label">Blockchain:</span>
                          <span class="detail-value sample-text">Ethereum</span>
                        </div>
                        <div class="detail-row">
                          <span class="detail-label">Duration:</span>
                          <span class="detail-value sample-text">3:45</span>
                        </div>
                      </div>

                      <div class="nft-stats">
                        <div class="stat-item">
                          <v-icon size="16" color="grey">mdi-play</v-icon>
                          <span class="sample-text">1.2K plays</span>
                        </div>
                        <div class="stat-item">
                          <v-icon size="16" color="grey">mdi-heart</v-icon>
                          <span class="sample-text">234</span>
                        </div>
                        <div class="stat-item">
                          <v-icon size="16" color="grey">mdi-download</v-icon>
                          <span class="sample-text">Available</span>
                        </div>
                      </div>
                    </div>

                    <div class="nft-actions">
                      <v-btn
                        variant="outlined"
                        prepend-icon="mdi-play"
                        disabled
                        block
                        class="sample-button play-button"
                      >
                        Play Track
                      </v-btn>
                      <div class="action-buttons-grid">
                        <v-btn
                          variant="outlined"
                          prepend-icon="mdi-cash"
                          disabled
                          class="sample-button sell-button"
                        >
                          Sell
                        </v-btn>
                        <v-btn
                          variant="outlined"
                          prepend-icon="mdi-swap-horizontal"
                          disabled
                          class="sample-button transfer-button"
                        >
                          Transfer
                        </v-btn>
                      </div>
                      <div class="action-buttons-row">
                        <v-btn
                          icon
                          size="small"
                          variant="text"
                          disabled
                          title="Share"
                        >
                          <v-icon size="18">mdi-share-variant</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          size="small"
                          variant="text"
                          disabled
                          title="Info"
                        >
                          <v-icon size="18">mdi-information</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          size="small"
                          variant="text"
                          disabled
                          title="Download"
                        >
                          <v-icon size="18">mdi-download</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>

                  <!-- Geo NFT (Sample) -->
                  <div 
                    v-if="showSampleNFT('geo')" 
                    class="nft-card sample-nft geo-nft"
                  >
                    <div class="nft-badge-container">
                      <v-chip size="small" color="teal" class="nft-type-badge">
                        <v-icon left size="14">mdi-map-marker-radius</v-icon>
                        Geo NFT
                      </v-chip>
                      <div class="sample-overlay-badge">
                        <v-chip size="small" color="grey" variant="outlined">
                          <v-icon left size="12">mdi-information</v-icon>
                          Sample
                        </v-chip>
                      </div>
                    </div>

                    <div class="nft-image geo-image">
                      <div class="geo-map-container">
                        <img src="https://api.mapbox.com/styles/v1/mapbox/dark-v10/static/pin-s+00d4aa(139.6503,35.6762)/139.6503,35.6762,10,0/400x400?access_token=pk.eyJ1Ijoic3BvcnR1cCIsImEiOiJBT1lMSXdRIn0.apykLhgcJrk0jVKtzb8FfQ" alt="Geo Location" class="geo-map sample-map" />
                        <div class="geo-overlay">
                          <v-icon size="64" color="white" class="geo-pin">mdi-map-marker</v-icon>
                        </div>
                      </div>
                      <div class="nft-overlay">
                        <v-btn
                          icon
                          size="x-large"
                          variant="text"
                          class="play-btn-nft"
                          disabled
                        >
                          <v-icon size="48">mdi-play-circle</v-icon>
                        </v-btn>
                      </div>
                      <div class="nft-rarity">
                        <v-chip size="x-small" color="teal" class="rarity-chip">
                          <v-icon left size="12">mdi-map-marker-star</v-icon>
                          Geo Exclusive
                        </v-chip>
                      </div>
                    </div>

                    <div class="nft-content-body">
                      <div class="nft-header">
                        <h3 class="nft-title sample-text">Tokyo Nights Ambient</h3>
                        <p class="nft-artist sample-text">
                          <v-icon size="14" class="artist-icon">mdi-account-music</v-icon>
                          Sample Artist
                        </p>
                      </div>

                      <div class="geo-location-info">
                        <div class="location-detail">
                          <v-icon size="18" color="teal">mdi-map-marker</v-icon>
                          <div class="location-text">
                            <span class="location-name sample-text">Tokyo, Japan</span>
                            <span class="location-coords sample-text">35.6762° N, 139.6503° E</span>
                          </div>
                        </div>
                        <div class="location-detail">
                          <v-icon size="18" color="teal">mdi-radius</v-icon>
                          <span class="sample-text">Playable within 5km radius</span>
                        </div>
                      </div>

                      <div class="nft-details">
                        <div class="detail-row">
                          <span class="detail-label">Token ID:</span>
                          <span class="detail-value sample-text">#9876543210</span>
                        </div>
                        <div class="detail-row">
                          <span class="detail-label">Edition:</span>
                          <span class="detail-value sample-text">1 of 50</span>
                        </div>
                        <div class="detail-row">
                          <span class="detail-label">Duration:</span>
                          <span class="detail-value sample-text">5:23</span>
                        </div>
                      </div>

                      <div class="nft-stats">
                        <div class="stat-item">
                          <v-icon size="16" color="grey">mdi-play</v-icon>
                          <span class="sample-text">856 plays</span>
                        </div>
                        <div class="stat-item">
                          <v-icon size="16" color="grey">mdi-map-marker-check</v-icon>
                          <span class="sample-text">In range</span>
                        </div>
                      </div>
                    </div>

                    <div class="nft-actions">
                      <v-btn
                        variant="outlined"
                        prepend-icon="mdi-play"
                        disabled
                        block
                        class="sample-button play-button"
                      >
                        Play Track
                      </v-btn>
                      <div class="action-buttons-grid">
                        <v-btn
                          variant="outlined"
                          prepend-icon="mdi-cash"
                          disabled
                          class="sample-button sell-button"
                        >
                          Sell
                        </v-btn>
                        <v-btn
                          variant="outlined"
                          prepend-icon="mdi-swap-horizontal"
                          disabled
                          class="sample-button transfer-button"
                        >
                          Transfer
                        </v-btn>
                      </div>
                      <div class="action-buttons-row">
                        <v-btn
                          icon
                          size="small"
                          variant="text"
                          disabled
                          title="View on Map"
                        >
                          <v-icon size="18">mdi-map</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          size="small"
                          variant="text"
                          disabled
                          title="Share"
                        >
                          <v-icon size="18">mdi-share-variant</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          size="small"
                          variant="text"
                          disabled
                          title="Info"
                        >
                          <v-icon size="18">mdi-information</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>

                  <!-- Location Recording NFT (Sample) -->
                  <div 
                    v-if="showSampleNFT('location')" 
                    class="nft-card sample-nft location-nft"
                  >
                    <div class="nft-badge-container">
                      <v-chip size="small" color="orange" class="nft-type-badge">
                        <v-icon left size="14">mdi-microphone</v-icon>
                        Location Recording
                      </v-chip>
                      <div class="sample-overlay-badge">
                        <v-chip size="small" color="grey" variant="outlined">
                          <v-icon left size="12">mdi-information</v-icon>
                          Sample
                        </v-chip>
                      </div>
                    </div>

                    <div class="nft-image">
                      <img src="@/assets/images/muzible_tickets.webp" alt="Recording Cover" />
                      <div class="nft-overlay">
                        <v-btn
                          icon
                          size="x-large"
                          variant="text"
                          class="play-btn-nft"
                          disabled
                        >
                          <v-icon size="48">mdi-play-circle</v-icon>
                        </v-btn>
                      </div>
                      <div class="recording-indicator">
                        <v-chip size="x-small" color="red" class="live-chip">
                          <v-icon left size="12" class="pulse-icon">mdi-record-circle</v-icon>
                          Live Recording
                        </v-chip>
                      </div>
                    </div>

                    <div class="nft-content-body">
                      <div class="nft-header">
                        <h3 class="nft-title sample-text">Central Park Ambience</h3>
                        <p class="nft-artist sample-text">
                          <v-icon size="14" class="artist-icon">mdi-account</v-icon>
                          Sample User
                        </p>
                      </div>

                      <div class="recording-info">
                        <div class="recording-detail">
                          <v-icon size="18" color="orange">mdi-map-marker</v-icon>
                          <span class="sample-text">New York, Central Park</span>
                        </div>
                        <div class="recording-detail">
                          <v-icon size="18" color="orange">mdi-calendar</v-icon>
                          <span class="sample-text">Recorded: Nov 15, 2024</span>
                        </div>
                        <div class="recording-detail">
                          <v-icon size="18" color="orange">mdi-microphone-variant</v-icon>
                          <span class="sample-text">Voice Note / Field Recording</span>
                        </div>
                      </div>

                      <div class="nft-details">
                        <div class="detail-row">
                          <span class="detail-label">Token ID:</span>
                          <span class="detail-value sample-text">#5555555555</span>
                        </div>
                        <div class="detail-row">
                          <span class="detail-label">Edition:</span>
                          <span class="detail-value sample-text">Unique (1 of 1)</span>
                        </div>
                        <div class="detail-row">
                          <span class="detail-label">Duration:</span>
                          <span class="detail-value sample-text">2:15</span>
                        </div>
                      </div>

                      <div class="nft-stats">
                        <div class="stat-item">
                          <v-icon size="16" color="grey">mdi-play</v-icon>
                          <span class="sample-text">342 plays</span>
                        </div>
                        <div class="stat-item">
                          <v-icon size="16" color="grey">mdi-waveform</v-icon>
                          <span class="sample-text">Ambient</span>
                        </div>
                      </div>
                    </div>

                    <div class="nft-actions">
                      <v-btn
                        variant="outlined"
                        prepend-icon="mdi-play"
                        disabled
                        block
                        class="sample-button play-button"
                      >
                        Play Recording
                      </v-btn>
                      <div class="action-buttons-grid">
                        <v-btn
                          variant="outlined"
                          prepend-icon="mdi-cash"
                          disabled
                          class="sample-button sell-button"
                        >
                          Sell
                        </v-btn>
                        <v-btn
                          variant="outlined"
                          prepend-icon="mdi-swap-horizontal"
                          disabled
                          class="sample-button transfer-button"
                        >
                          Transfer
                        </v-btn>
                      </div>
                      <div class="action-buttons-row">
                        <v-btn
                          icon
                          size="small"
                          variant="text"
                          disabled
                          title="View on Map"
                        >
                          <v-icon size="18">mdi-map</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          size="small"
                          variant="text"
                          disabled
                          title="Share"
                        >
                          <v-icon size="18">mdi-share-variant</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          size="small"
                          variant="text"
                          disabled
                          title="Download"
                        >
                          <v-icon size="18">mdi-download</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>

                  <!-- Real NFTs from API would be rendered here -->
                  <div 
                    v-for="nft in filteredNFTs" 
                    :key="nft.id"
                    class="nft-card"
                    :class="`${nft.type}-nft`"
                  >
                    <!-- NFT card structure same as samples but without sample classes -->
                    <!-- This will be populated when real NFT data is available -->
                  </div>
                </div>

                <!-- Empty State -->
                <div v-else class="nft-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="80" color="grey">mdi-image-off-outline</v-icon>
                  </div>
                  <h3 class="empty-title">No NFTs Found</h3>
                  <p class="empty-subtitle">
                    {{ searchQuery ? 'Try adjusting your search or filters' : 'You don\'t have any NFTs in your collection yet' }}
                  </p>
                  <div class="empty-actions" v-if="!searchQuery">
                    <v-btn
                      variant="outlined"
                      prepend-icon="mdi-plus"
                      @click="mintNFT()"
                      class="empty-action-btn"
                      size="large"
                    >
                      Mint Your First NFT
                    </v-btn>
                  </div>
                </div>
              </div>

              <!-- Tips Section -->
              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <div class="tips-section">
                <h2 class="section-title">
                  <v-icon left>mdi-lightbulb</v-icon>
                  About NFT Collections
                </h2>

                <div class="tips-grid">
                  <div class="tip-card">
                    <v-icon class="tip-icon" color="purple">mdi-music-box</v-icon>
                    <h4 class="tip-title">Music NFTs</h4>
                    <p class="tip-text">
                      Own unique music tracks as NFTs. Trade, collect, and enjoy exclusive content from your favorite artists.
                    </p>
                  </div>

                  <div class="tip-card">
                    <v-icon class="tip-icon" color="teal">mdi-map-marker-radius</v-icon>
                    <h4 class="tip-title">Geo NFTs</h4>
                    <p class="tip-text">
                      Location-based music that can only be played within specific geographic areas. Discover exclusive regional tracks.
                    </p>
                  </div>

                  <div class="tip-card">
                    <v-icon class="tip-icon" color="orange">mdi-microphone</v-icon>
                    <h4 class="tip-title">Location Recordings</h4>
                    <p class="tip-text">
                      Capture and mint your own field recordings as unique NFTs tied to specific places and moments.
                    </p>
                  </div>

                  <div class="tip-card">
                    <v-icon class="tip-icon" color="success">mdi-cash</v-icon>
                    <h4 class="tip-title">Trade & Sell</h4>
                    <p class="tip-text">
                      List your NFTs for sale on the marketplace or transfer them to other collectors directly.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <v-row
          :style="(this.isMobileXs || this.isMobilePlayer3) ? 'padding-top:170px!important' : 'padding-top:123px!important'"
        ></v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";


export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'CollectionsNFT',

  components: {

  },
  data: () => ({
    navbar: false,
    user: null,
    nftCollections: [],
    searchQuery: "",
    searching: false,
    sortBy: "recent",
    nftFilter: "all",
    filterOptions: [
      { title: 'All NFTs', value: 'all' },
      { title: 'Music NFT', value: 'standard' },
      { title: 'Geo NFT', value: 'geo' },
      { title: 'Location Recording', value: 'location' },
    ],
    sortOptions: [
      { title: 'Most Recent', value: 'recent' },
      { title: 'Name A-Z', value: 'name_asc' },
      { title: 'Name Z-A', value: 'name_desc' },
      { title: 'Highest Value', value: 'value' },
      { title: 'Most Played', value: 'plays' },
    ],

  }),
  mounted() {
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {

  },
  destroyed() {
  },
  watch: {
    '$store.state.user': function () {
      this.user = this.$store.getters.getUserData;
    },
    searchQuery(newVal) {
      if (newVal) {
        this.searching = true;
        setTimeout(() => {
          this.searching = false;
        }, 500);
      }
    }
  },
  computed: {
    hasSampleNFTs() {
      // Always show sample NFTs for demonstration
      return true;
    },
    isfullScreen() {
      if (this.isMobile && this.isMobileXs) {
        return false;
      } else {
        return true;
      }
    },
    isLogged() {
      return this.$store.getters.getUserData != null
    },
    isDesktop() {
      if (!this.navbar) {
        return true;
      } else {
        return false;
      }
    },
    getGextPanel() {
      if (this.navbar) {
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },
    filteredNFTs() {
      let filtered = [...this.nftCollections];

      // Type filter
      if (this.nftFilter !== 'all') {
        filtered = filtered.filter(nft => nft.type === this.nftFilter);
      }

      // Search filter
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter(nft => 
          nft.name.toLowerCase().includes(query) ||
          (nft.artist && nft.artist.toLowerCase().includes(query)) ||
          (nft.tokenId && nft.tokenId.toLowerCase().includes(query))
        );
      }

      // Sort
      switch(this.sortBy) {
        case 'name_asc':
          filtered.sort((a, b) => a.name.localeCompare(b.name));
          break;
        case 'name_desc':
          filtered.sort((a, b) => b.name.localeCompare(a.name));
          break;
        case 'value':
          filtered.sort((a, b) => (b.value || 0) - (a.value || 0));
          break;
        case 'plays':
          filtered.sort((a, b) => (b.plays || 0) - (a.plays || 0));
          break;
        case 'recent':
        default:
          filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      }

      return filtered;
    },
    totalNFTs() {
      return this.nftCollections.length;
    }
  },
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;

      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }

      this.loadNFTCollections();
    }
  },
  methods: {
    showSampleNFT(type) {
      // Show sample NFT if:
      // 1. Filter is 'all' OR
      // 2. Filter matches the NFT type
      // AND if search query is empty or matches sample data
      
      if (this.nftFilter !== 'all' && this.nftFilter !== type) {
        return false;
      }

      if (!this.searchQuery) {
        return true;
      }

      // Check if search query matches sample NFT data
      const query = this.searchQuery.toLowerCase();
      const sampleData = {
        standard: {
          name: 'Epic Electronic Anthem',
          artist: 'Sample Artist',
          tokenId: '#1234567890'
        },
        geo: {
          name: 'Tokyo Nights Ambient',
          artist: 'Sample Artist',
          tokenId: '#9876543210',
          location: 'Tokyo, Japan'
        },
        location: {
          name: 'Central Park Ambience',
          artist: 'Sample User',
          tokenId: '#5555555555',
          location: 'New York, Central Park'
        }
      };

      const data = sampleData[type];
      return data.name.toLowerCase().includes(query) ||
             data.artist.toLowerCase().includes(query) ||
             data.tokenId.toLowerCase().includes(query) ||
             (data.location && data.location.toLowerCase().includes(query));
    },
    loadNFTCollections() {
      this.$store.dispatch('getCollectionsNFT', { 
        token: this.user.token
      }).then(response => {
        this.nftCollections = this.$store.getters.getCollectionsNFT || [];
      }).catch(error => {
        if (!error.response) {
          this.notifyError("Network problem, please try again later..");
        }
      })
    },
    refreshCollections() {
      this.loadNFTCollections();
      this.notify('NFT collections refreshed!');
    },
    findNFT() {
      this.notify('Find NFT feature coming soon!');
    },
    playNFT(id) {
      this.notify(`Playing NFT ${id}`);
    },
    sellNFT(id) {
      this.notify(`Sell NFT feature coming soon for ${id}`);
    },
    transferNFT(id) {
      this.notify(`Transfer NFT feature coming soon for ${id}`);
    },
    shareNFT(id) {
      this.notify(`Sharing NFT ${id}`);
    },
    viewNFTInfo(id) {
      this.notify(`Viewing NFT info ${id}`);
    },
    downloadNFT(id) {
      this.notify(`Downloading NFT ${id}`);
    },
    viewOnMap(id) {
      this.notify(`Viewing NFT ${id} on map`);
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      });
    },
    checkScreenSize() {
      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    handleClickMenu(link) {
      if (link === 'TryMuzE') {
        window.location.href = 'https://muze.muzible.com/';
      } else if (link === 'TryVerse') {
        window.location.href = 'https://verse.muzible.com/';
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Collections Header */
.collections-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.header-icon {
  font-size: 48px !important;
  color: white;
}

.header-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.header-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 20px 0;
  line-height: 1.5;
}

.header-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.action-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.action-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.create-btn:hover {
  background: rgba(76, 175, 80, 0.2) !important;
  border-color: rgba(76, 175, 80, 0.6) !important;
}

/* Section */
.collections-section {
  margin-bottom: 32px;
}

.section-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Search and Filters Container */
.search-filters-container {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

@media (max-width: 1024px) {
  .search-filters-container {
    grid-template-columns: 1fr 1fr;
  }

  .search-field {
    grid-column: 1 / -1;
  }
}

@media (max-width: 768px) {
  .search-filters-container {
    grid-template-columns: 1fr;
  }
}

.search-field,
.filter-select,
.sort-select {
  font-family: "Darker Grotesque", sans-serif !important;
}

:deep(.search-field .v-field),
:deep(.filter-select .v-field),
:deep(.sort-select .v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

:deep(.search-field .v-field:hover),
:deep(.filter-select .v-field:hover),
:deep(.sort-select .v-field:hover) {
  border-color: rgba(255, 255, 255, 0.4) !important;
}

:deep(.search-field .v-field--focused),
:deep(.filter-select .v-field--focused),
:deep(.sort-select .v-field--focused) {
  border-color: rgba(255, 255, 255, 0.6) !important;
}

:deep(.search-field .v-field__input),
:deep(.filter-select .v-field__input),
:deep(.sort-select .v-field__input) {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 500;
}

/* Results Info */
.results-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
}

.results-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

/* NFT Content */
.nft-content {
  min-height: 400px;
}

/* NFT Grid */
.nft-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 24px;
}

@media (max-width: 768px) {
  .nft-grid {
    grid-template-columns: 1fr;
  }
}

/* NFT Card */
.nft-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.98), rgba(18, 18, 18, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.4s ease;
  position: relative;
}

.nft-card:hover {
  transform: translateY(-8px);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);
}

/* Sample NFT Styles */
.sample-nft {
  opacity: 0.65;
  pointer-events: none;
}

.sample-text {
  color: rgba(255, 255, 255, 0.5) !important;
}

.sample-button {
  opacity: 0.6;
}

.sample-map {
  opacity: 0.4;
  filter: grayscale(0.8);
}

/* NFT Badge Container */
.nft-badge-container {
  position: absolute;
  top: 16px;
  left: 16px;
  right: 16px;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.nft-type-badge {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 700 !important;
  backdrop-filter: blur(10px);
}

.sample-overlay-badge {
  backdrop-filter: blur(10px);
}

/* NFT Image */
.nft-image {
  position: relative;
  width: 100%;
  padding-top: 100%;
  background: rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.nft-image img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nft-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.nft-card:hover .nft-overlay {
  opacity: 1;
}

.play-btn-nft {
  color: white !important;
  transition: transform 0.3s ease;
}

.play-btn-nft:hover {
  transform: scale(1.1);
}

.nft-rarity {
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 5;
}

.rarity-chip {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 700 !important;
  backdrop-filter: blur(10px);
  background: rgba(0, 0, 0, 0.8) !important;
}

/* Geo NFT Specific */
.geo-nft .nft-image {
  background: rgba(0, 123, 123, 0.1);
}

.geo-map-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.geo-map {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.geo-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
  50% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.8; }
}

.geo-pin {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.8));
}

/* Location Recording Specific */
.location-nft .nft-image {
  background: rgba(255, 152, 0, 0.1);
}

.recording-indicator {
  position: absolute;
  bottom: 16px;
  left: 16px;
  z-index: 5;
}

.live-chip {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 700 !important;
  backdrop-filter: blur(10px);
  background: rgba(0, 0, 0, 0.8) !important;
}

.pulse-icon {
  animation: pulse-red 1.5s infinite;
}

@keyframes pulse-red {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* NFT Content Body */
.nft-content-body {
  padding: 20px;
}

.nft-header {
  margin-bottom: 16px;
}

.nft-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: white;
  margin: 0 0 8px 0;
  line-height: 1.2;
}

.nft-artist {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
}

.artist-icon {
  opacity: 0.7;
}

/* Geo Location Info */
.geo-location-info {
  background: rgba(0, 123, 123, 0.1);
  border: 1px solid rgba(0, 188, 212, 0.3);
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
}

.location-detail {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}

.location-detail:last-child {
  margin-bottom: 0;
}

.location-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.location-name {
  font-weight: 600;
  color: white;
}

.location-coords {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
}

/* Recording Info */
.recording-info {
  background: rgba(255, 152, 0, 0.1);
  border: 1px solid rgba(255, 152, 0, 0.3);
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
}

.recording-detail {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}

.recording-detail:last-child {
  margin-bottom: 0;
}

/* NFT Details */
.nft-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.detail-label {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

.detail-value {
  color: white;
  font-weight: 600;
  font-family: "Darker Grotesque", sans-serif;
}

/* NFT Stats */
.nft-stats {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
}

/* NFT Actions */
.nft-actions {
  padding: 0 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.nft-actions .v-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
}

.play-button {
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.play-button:not(:disabled):hover {
  background: rgba(76, 175, 80, 0.2) !important;
  border-color: rgba(76, 175, 80, 0.6) !important;
}

.action-buttons-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.sell-button {
  border-color: rgba(255, 193, 7, 0.5) !important;
  color: rgba(255, 193, 7, 0.9) !important;
}

.sell-button:not(:disabled):hover {
  background: rgba(255, 193, 7, 0.2) !important;
  border-color: rgba(255, 193, 7, 0.8) !important;
  color: rgba(255, 193, 7, 1) !important;
}

.transfer-button {
  border-color: rgba(33, 150, 243, 0.5) !important;
  color: rgba(33, 150, 243, 0.9) !important;
}

.transfer-button:not(:disabled):hover {
  background: rgba(33, 150, 243, 0.2) !important;
  border-color: rgba(33, 150, 243, 0.8) !important;
  color: rgba(33, 150, 243, 1) !important;
}

.action-buttons-row {
  display: flex;
  justify-content: center;
  gap: 8px;
}

/* Empty State */
.nft-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 60px 20px;
  text-align: center;
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
}

.empty-icon-wrapper {
  margin-bottom: 24px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.empty-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: white;
  margin-bottom: 12px;
}

.empty-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 32px;
  max-width: 500px;
  line-height: 1.6;
}

.empty-actions {
  margin-bottom: 0;
}

.empty-action-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  padding: 0 32px !important;
}

.empty-action-btn:hover {
  background: rgba(76, 175, 80, 0.2) !important;
  border-color: rgba(76, 175, 80, 0.6) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

/* Tips Section */
.tips-section {
  margin-top: 40px;
}

.tips-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
}

.tip-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  transition: all 0.3s ease;
}

.tip-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.tip-icon {
  font-size: 40px !important;
  margin-bottom: 16px;
}

.tip-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: white;
  margin-bottom: 8px;
}

.tip-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  margin: 0;
}

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.collections-section,
.nft-empty-state,
.tips-section,
.nft-card {
  animation: slideIn 0.4s ease forwards;
}

.nft-card:nth-child(1) { animation-delay: 0s; }
.nft-card:nth-child(2) { animation-delay: 0.1s; }
.nft-card:nth-child(3) { animation-delay: 0.2s; }

/* Override Vuetify */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-chip) {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 600 !important;
}

/* Responsive */
@media (max-width: 768px) {
  .header-title {
    font-size: 32px;
  }

  .header-actions {
    width: 100%;
  }

  .action-btn {
    flex: 1;
  }

  .section-title {
    font-size: 24px;
  }

  .nft-title {
    font-size: 20px;
  }

  .tips-grid {
    grid-template-columns: 1fr;
  }
}
</style>